import { memo } from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

export const TimeInForWorkIllustration = () => (
  <Svg width={251} height={250} fill="none">
    <G clipPath="url(#a)">
      <Path
        d="M133.98 94.6s-.01-.01-.02-.01c-5.24-2.66-15.69-2.47-20.78-2.18-14.08.62-27.92 3.91-40.78 9.68-15.57-16.84-31.95-38.67-31.95-55.91.01 3.75 26.6 6.8 59.41 6.8 32.81 0 59.39-3.04 59.41-6.8 0 14.78-12.04 32.93-25.29 48.42ZM95.42 124.63v57.67c-2.38-3.74-5.79-6.63-10.21-6.94-2.22-.14-4.44.23-6.49 1.09-2.05.85-3.88 2.17-5.35 3.84-5.08 5.92-3.29 4.65-9.9 5.53-4.37.55-8.5 2.29-11.94 5.04l-.5.49-3.36 3.29a32.977 32.977 0 0 0-4.18 6.43c-.02.05-.05.1-.08.15-.52.98-.95 1.97-1.25 2.94-.2.51-.37 1.02-.53 1.54l-.01.02c-.42 1.18-.9 2.51-1.14 3.71.33-6.83 3.06-14.65 7.19-22.77l3.86-7.01c4.12-6.9 8.63-13.55 13.51-19.92l12.08-14.99a427.48 427.48 0 0 1 18.3-20.11Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M72.4 102.09c3.72 4.03 7.4 7.78 10.79 11.11.34.34.68.67 1.02.99 3.47 3.38 6.6 6.28 9.14 8.58.37.34.73.66 1.07.97.35.31.68.61 1 .89M40.49 209.43v.02c-.02.45-.03.89-.03 1.33"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M159.28 210.79c-1.44-8.54-6.92-6.89-10.1-10.31-.26-.29-.51-.61-.74-.97-.07-.11-.14-.23-.21-.36a9.72 9.72 0 0 1-.38-.79c-.06-.14-.11-.29-.17-.44-.04-.11-.07-.22-.11-.33a12.052 12.052 0 0 1-.29-1.09c-.03-.13-.05-.26-.08-.4-.07-.4-.14-.84-.19-1.3a25.9 25.9 0 0 0-.1-.92c-.03-.3-.07-.6-.12-.89l-.12-.75c-.09-.49-.19-.96-.3-1.42-.22-.92-.48-1.77-.8-2.55-.08-.2-.16-.39-.24-.58a13 13 0 0 0-.61-1.24c-.55-.97-1.18-1.83-1.9-2.55-3.84-3.92-10.09-4.32-18.14-1.98-.06-.48-.14-.96-.24-1.44-.04-.23-.1-.47-.16-.71-.11-.47-.25-.93-.4-1.39-.23-.69-.5-1.37-.81-2.03-.08-.19-.17-.37-.28-.55-.2-.35-.45-.69-.73-.99-.06-.07-.14-.15-.21-.22-.07-.08-.14-.15-.21-.21h-.01c-.61-.55-1.32-.96-2.11-1.21-.78-.26-1.6-.34-2.42-.25-.82.09-1.61.35-2.32.77a28.31 28.31 0 0 0-9.38 6.67c-.38.41-.74.83-1.1 1.26v-36.88l.01-20.1c4.2 4.32 10.96 11.48 18.3 20.1l12.07 14.99c12.97 17.13 24.6 36.54 24.6 51.06Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M104.31 124.64h-.01.01Zm0 0c.45-.41.91-.82 1.36-1.23.78-.69 1.56-1.39 2.33-2.11.55-.51 1.12-1.04 1.72-1.59.3-.26.6-.54.9-.84.31-.28.62-.57.93-.87.31-.3.63-.6.96-.91.67-.62 1.32-1.25 1.98-1.9.34-.32.69-.65 1.03-.99.34-.34.69-.68 1.04-1.02.04-.03.08-.07.11-.11.67-.66 1.36-1.34 2.05-2.03 4.86-4.85 10.15-10.45 15.27-16.43"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M47.67 214.04c-4.56-.96-7.17-2.05-7.22-3.22v2.38c0 1.18 2.62 2.28 7.22 3.25v-2.41ZM99.86 217.59c-19.92 0-37.55-1.12-48.33-2.85v2.41c10.78 1.72 28.41 2.85 48.33 2.85 32.81 0 59.4-3.04 59.41-6.8v-2.42c0 3.75-26.6 6.8-59.41 6.8v.01Z"
        fill="#595959"
      />
      <Path
        d="M47.67 214.04c-4.56-.96-7.17-2.05-7.22-3.22v2.38c0 1.18 2.62 2.28 7.22 3.25M51.53 217.16c10.78 1.72 28.41 2.85 48.33 2.85 32.81 0 59.4-3.04 59.41-6.8v-2.42c0 3.76-26.6 6.8-59.41 6.8-19.92 0-37.55-1.12-48.33-2.85M159.28 43.79v2.39c-.02 3.76-26.61 6.8-59.41 6.8s-59.4-3.05-59.41-6.8v-2.42c0 3.76 26.6 6.81 59.41 6.81 12.82 0 24.69-.47 34.39-1.25 3.42-.29 6.57-.6 9.4-.96.07-.01.14-.02.22-.02.6-.08 1.18-.16 1.75-.24.03 0 .06 0 .08-.01.59-.08 1.15-.16 1.7-.24.93-.15 1.82-.3 2.66-.45.21-.03.41-.07.61-.11 2.23-.42 4.08-.87 5.48-1.35.43-.14.82-.29 1.16-.44.16-.07.3-.13.44-.2.32-.16.59-.32.81-.48.31-.23.53-.47.63-.71.03-.06.05-.11.06-.17.01-.05.02-.1.02-.15v0Z"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M99.86 36.96c-32.81 0-59.41 3.05-59.41 6.8s26.6 6.8 59.41 6.8c32.81 0 59.41-3.05 59.41-6.8s-26.6-6.8-59.41-6.8Z"
        fill="#595959"
      />
      <Path
        d="M99.86 36.96c-32.81 0-59.41 3.05-59.41 6.8s26.6 6.8 59.41 6.8c32.81 0 59.41-3.05 59.41-6.8s-26.6-6.8-59.41-6.8v0Z"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M159.28 210.79c0 3.75-26.6 6.8-59.41 6.8-.94 0-1.87 0-2.8-.01-.9 0-1.81-.01-2.7-.02-.63 0-1.25-.01-1.86-.02l-1.8-.03c-.61 0-1.22-.02-1.82-.03-.59-.02-1.18-.03-1.76-.04-14.58-.35-27.13-1.23-35.36-2.16 0 0-.08-.01-.23-.02-.56-.05-2.1-.2-3.86-.49-2.78-.45-6.11-1.25-6.99-2.59-.1-.16-.18-.33-.23-.52-.18-.6-.14-1.37.03-2.21v-.02c.24-1.2.72-2.53 1.14-3.71l.01-.02c.2-.56.39-1.08.53-1.54.3-.97.73-1.96 1.25-2.94.03-.05.06-.1.08-.15 2.29-4.26 6.17-8.34 7.54-9.72l.5-.49c3.44-2.75 7.57-4.49 11.94-5.04 6.61-.88 4.82.39 9.9-5.53 1.47-1.67 3.3-2.99 5.35-3.84 2.05-.86 4.27-1.23 6.49-1.09 4.42.31 7.83 3.2 10.21 6.94v-57.67c-.32-.28-.65-.58-1-.89-.34-.31-.7-.63-1.07-.97-2.54-2.3-5.67-5.2-9.14-8.58-.34-.32-.68-.65-1.02-.99a318.23 318.23 0 0 1-10.79-11.11 49.138 49.138 0 0 0 18.19 1.95c.02.01.03.01.05 0 .54-.04 1.09-.1 1.63-.16.48-.05.95-.11 1.42-.19.08 0 .15 0 .23-.03.19-.02.39-.05.58-.08 6.05-.89 11.01-2.5 15.87-4.11.38-.12.75-.24 1.12-.37 2.41-.8 4.81-1.59 7.33-2.25.51-.14 1.01-.28 1.51-.41.8-.2 1.58-.39 2.37-.56.21-.05.43-.1.64-.14 1-.21 2-.39 3.01-.53a60.625 60.625 0 0 1 3.88-.44c.33-.03.68-.05 1.02-.07.62-.03 1.25-.06 1.89-.08l.82-.03h.02l-.01.01c-2.3 2.66-4.65 5.28-7.04 7.87-2.39 2.58-4.82 5.13-7.3 7.63-.31.31-.61.62-.92.93-.68.68-1.36 1.36-2.05 2.03-.03.04-.07.08-.11.11-.35.34-.7.68-1.04 1.02-.34.34-.69.67-1.03.99-.79.79-1.59 1.55-2.39 2.31-.49.47-.98.93-1.47 1.37-.3.3-.6.58-.9.84-.6.55-1.17 1.08-1.72 1.59-.77.72-1.55 1.42-2.33 2.11-.45.41-.91.82-1.36 1.23v35.1l-.01 21.89c.36-.43.72-.85 1.1-1.25.38-.42.76-.81 1.16-1.19a28.31 28.31 0 0 1 8.22-5.49c.71-.42 1.5-.68 2.32-.77.82-.09 1.64-.01 2.42.25.79.25 1.5.66 2.11 1.21h.01c.07.06.14.13.21.21a6.313 6.313 0 0 1 .94 1.21c.11.18.2.36.28.55.31.66.58 1.34.81 2.03.15.46.28.92.4 1.39.06.24.12.48.16.71.1.48.17.96.23 1.44h.01c8.05-2.34 14.3-1.94 18.14 1.98.72.72 1.35 1.58 1.9 2.55.21.39.41.8.61 1.23.08.2.16.39.24.59.31.78.57 1.63.8 2.55.11.46.21.93.3 1.42l.12.75c.05.29.09.59.12.89l.09.92c.05.46.12.9.2 1.3.03.14.05.27.08.4s.06.26.09.38c.06.25.13.48.2.71.04.11.07.22.11.33.06.15.11.3.17.44.11.28.24.55.38.79.07.13.14.25.21.36.23.36.48.68.74.97 3.18 3.42 8.66 1.77 10.1 10.31h-.01Z"
        fill="#F3123C"
      />
      <Path
        d="M159.28 210.79c0 3.75-26.6 6.8-59.41 6.8-.94 0-1.87 0-2.8-.01-.9 0-1.81-.01-2.7-.02-.63 0-1.25-.01-1.86-.02l-1.8-.03c-.61 0-1.22-.02-1.82-.03-.59-.02-1.18-.03-1.76-.04-.57-.02-1.14-.04-1.71-.05-1.15-.04-2.29-.07-3.42-.11-.84-.03-1.68-.06-2.51-.1-.83-.03-1.65-.07-2.46-.11-.54-.03-1.08-.06-1.61-.08-.8-.04-1.59-.08-2.37-.13-.78-.04-1.55-.09-2.31-.14-.51-.04-1.01-.07-1.51-.1-.37-.03-.75-.06-1.11-.08-.37-.03-.73-.06-1.09-.08-.73-.06-1.44-.12-2.14-.17l-1.39-.12c-1.14-.1-2.25-.21-3.32-.32-.54-.06-1.06-.11-1.58-.17l-.31-.03c-.29-.04-.57-.07-.84-.1-.13-.02-.26-.03-.38-.05l-.74-.09c-.37-.04-.73-.09-1.09-.14-.36-.05-.71-.09-1.06-.14-.41-.05-.82-.11-1.22-.17-.49-.07-.96-.15-1.42-.22l-3.86-.7c-.58-.12-1.14-.25-1.65-.38-.26-.06-.51-.12-.75-.19-.24-.06-.48-.13-.7-.19-.02-.01-.05-.01-.07-.02-.4-.11-.76-.23-1.1-.35-.35-.13-.68-.25-.97-.38-.14-.06-.28-.12-.41-.19-.13-.06-.25-.12-.37-.19-.08-.04-.15-.09-.22-.13-.07-.04-.14-.09-.2-.13-.1-.07-.19-.14-.27-.21-.17-.14-.29-.28-.37-.43a.476.476 0 0 1-.08-.18.193.193 0 0 1-.03-.1l-.01-.02s-.02-.09-.02-.13v-.04c.26-1.72.65-3.41 1.17-5.06l.01-.02c.16-.52.33-1.03.53-1.54.37-1 .79-1.98 1.25-2.94.03-.05.06-.1.08-.15 1.14-2.29 2.53-4.45 4.18-6.43l3.36-3.29.5-.49c3.44-2.75 7.57-4.49 11.94-5.04 6.61-.88 4.82.39 9.9-5.53 1.47-1.67 3.3-2.99 5.35-3.84 2.05-.86 4.27-1.23 6.49-1.09 4.42.31 7.83 3.2 10.21 6.94v-57.67c-.32-.28-.65-.58-1-.89-.34-.31-.7-.63-1.07-.97-2.54-2.3-5.67-5.2-9.14-8.58-.34-.32-.68-.65-1.02-.99a318.23 318.23 0 0 1-10.79-11.11 49.138 49.138 0 0 0 18.19 1.95c.02.01.03.01.05 0 .54-.04 1.09-.1 1.63-.16.48-.05.95-.11 1.42-.19.08 0 .15 0 .23-.03.19-.02.39-.05.58-.08 6.05-.89 11.01-2.5 15.87-4.11.38-.12.75-.24 1.12-.37 2.41-.8 4.81-1.59 7.33-2.25.51-.14 1.01-.28 1.51-.41.8-.2 1.58-.39 2.37-.56.21-.05.43-.1.64-.14 1-.21 2-.39 3.01-.53a60.625 60.625 0 0 1 3.88-.44c.33-.03.68-.05 1.02-.07.62-.03 1.25-.06 1.89-.08l.82-.03h.02l-.01.01c-2.3 2.66-4.65 5.28-7.04 7.87-2.39 2.58-4.82 5.13-7.3 7.63-.31.31-.61.62-.92.93-.68.68-1.36 1.36-2.05 2.03-.03.04-.07.08-.11.11-.35.34-.7.68-1.04 1.02-.34.34-.69.67-1.03.99-.66.65-1.31 1.28-1.98 1.9-.13.14-.27.27-.41.41-.18.17-.36.34-.54.5-.31.3-.62.59-.93.87-.3.3-.6.58-.9.84-.6.55-1.17 1.08-1.72 1.59-.77.72-1.55 1.42-2.33 2.11-.45.41-.91.82-1.36 1.23h-.01v56.99c.36-.43.72-.85 1.1-1.25.38-.42.76-.81 1.16-1.19a28.31 28.31 0 0 1 8.22-5.49c.71-.42 1.5-.68 2.32-.77.82-.09 1.64-.01 2.42.25.79.25 1.5.66 2.11 1.21h.01c.07.06.14.13.21.21.07.07.15.15.21.22.28.3.53.64.73.99.11.18.2.36.28.55.31.66.58 1.34.81 2.03.15.46.29.92.4 1.39.06.24.12.48.16.71.1.48.18.96.24 1.44 8.05-2.34 14.3-1.94 18.14 1.98.72.72 1.35 1.58 1.9 2.55.22.39.42.8.61 1.23.08.2.16.39.24.59.32.78.58 1.63.8 2.55.11.46.21.93.3 1.42l.12.75c.05.29.09.59.12.89.04.3.07.61.1.92.05.46.12.9.19 1.3.03.14.05.27.08.4s.06.26.09.38c.06.25.13.48.2.71.04.11.07.22.11.33.06.15.11.3.17.44.12.28.25.55.38.79.07.13.14.25.21.36.23.36.48.68.74.97 3.18 3.42 8.66 1.77 10.1 10.31h-.01Z"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M133.15 94.62c-.64.02-1.28.03-1.89.08-.34.02-.69.04-1.02.07l-.69.06a52.532 52.532 0 0 0-6.84 1.05c-.79.17-1.57.36-2.37.56-2 .52-4.06 1.14-6.34 1.86-.82.26-1.66.53-2.5.8-.37.13-.74.25-1.12.37-5.13 1.65-10.59 3.34-16.45 4.19-.08.02-.15.03-.23.03a44.927 44.927 0 0 1-3.05.35c-.02.01-.03.01-.05 0-5.67.49-11.71.08-18.19-1.95 12.86-5.77 26.7-9.06 40.78-9.68 5.09-.29 15.54-.48 20.78 2.18v.01c-.28 0-.55.02-.83.02h.01Z"
        fill="#F3123C"
      />
      <Path
        d="M133.15 94.62c-.64.02-1.28.03-1.89.08-.34.02-.69.04-1.02.07l-.69.06a52.532 52.532 0 0 0-6.84 1.05c-.79.17-1.57.36-2.37.56-2 .52-4.06 1.14-6.34 1.86-.82.26-1.66.53-2.5.8-.37.13-.74.25-1.12.37-5.13 1.65-10.59 3.34-16.45 4.19-.08.02-.15.03-.23.03a44.927 44.927 0 0 1-3.05.35c-.02.01-.03.01-.05 0-5.67.49-11.71.08-18.19-1.95 12.86-5.77 26.7-9.06 40.78-9.68 5.09-.29 15.54-.48 20.78 2.18v.01c-.28 0-.55.02-.83.02h.01Z"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M230.98 152.52v61.55c.01.26-.04.51-.13.75-.1.24-.24.46-.42.64-.18.19-.39.34-.63.44-.24.1-.49.15-.75.15s-.51-.05-.75-.15c-.24-.1-.45-.25-.63-.44-.18-.18-.32-.4-.42-.64-.09-.24-.14-.49-.13-.75v-60.33l3.86-1.22Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M236.01 144.74v6.2l-5.03 1.58-3.86 1.22-18.96 5.99H40.91v-6.2h167.25l27.85-8.79Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m236.01 144.74-27.85 8.79H40.91l27.85-8.79h167.25ZM201.8 159.73v63.65c-.01.5-.22.98-.58 1.33-.36.36-.84.55-1.34.55-.5 0-.99-.19-1.35-.55-.36-.35-.57-.83-.58-1.33v-63.65h3.85ZM51.53 159.73v63.65c-.01.5-.22.98-.58 1.33-.36.36-.84.55-1.34.55-.5 0-.99-.19-1.35-.55-.36-.35-.57-.83-.58-1.33v-63.65h3.85Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m221.41 112.34-12.18 26.34c-.36.79-.89 1.5-1.54 2.08a6.5 6.5 0 0 1-2.25 1.3c.03-.14.05-.27.06-.4.02-.16.03-.32.03-.48v-.78l13.9-30.05 1.98 1.99ZM219.43 110.35l-13.9 30.05H162.2l13.89-30.05h43.34Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M205.53 140.4v.78c0 .16 0 .32-.03.48a4.654 4.654 0 0 1-.65 1.89c-.45.71-1.09 1.28-1.85 1.64l-17.98 5.23h-43.34v-3.59h43.34l20.51-6.43Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m205.53 140.4-20.5 6.43h-43.35l20.52-6.43h43.33Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m200.31 121.13 4.79 5.7-6.37 4.8M181.01 121.14l-6.12 4.35 4.9 6.34M189.05 118.91l2.49 12.91M27.22 126.23l15.84-2.29M27.2 116.74l15.89 1.92M25.48 168.46H37.4M31.44 174.42V162.5M6.62 195.86h6.5M9.88 199.11v-6.5M235.7 124.27l8.43 8.43M235.7 132.69l8.43-8.43M49.81 28.63l3.68 6.08 4.34-9.09"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m205.7 72.84-12.84-1.62s-.61 2.27-2.02 6.82a34.583 34.583 0 0 1-3.93 7.22l12.84 1.62a26.97 26.97 0 0 0 3.78-6.85c.86-2.35 1.59-4.75 2.18-7.18l-.01-.01Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m199.88 68.42-1.52 5.85"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m229.27 56.14-12.84-1.62s-.61 2.27-2.02 6.81a34.583 34.583 0 0 1-3.93 7.22l12.84 1.62a26.97 26.97 0 0 0 3.78-6.85c.86-2.35 1.59-4.75 2.18-7.18h-.01Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m223.45 51.73-1.52 5.85"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m226.43 84.18-12.84-1.62s-.61 2.27-2.02 6.81a34.583 34.583 0 0 1-3.93 7.22l12.84 1.62a26.97 26.97 0 0 0 3.78-6.85c.86-2.35 1.59-4.75 2.18-7.18h-.01Z"
        fill="#F5F5F5"
        stroke="#595959"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m220.61 79.76-1.52 5.84"
        stroke="#595959"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(6 25)" d="M0 0h238.75v200.73H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export const TimeInForWork = memo(TimeInForWorkIllustration)
